import React, { useCallback, useEffect, useState, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';

import { logging, logPostInfo } from '../../../actions/log';
import { CONTEXT } from '../../../config';
import { getRecoBanner, getRecoGroup, getRecommendList } from '../../../actions/wallpaper';
import CardIndex from '../../../card/CardIndex/CardIndex';
import Loading from '../../../components/Loading/Loading';
import ScrollTopWhite from '../../../components/ScrollTopWhite/ScrollTopWhite';
import WallpaperCard from '../../../components/WallpaperCard/WallpaperCard';
import Blank from '../Blank';
import styles from './WallpaperRecommend.module.less';
import _LogInView from '../../../components/_LogInView/_LogInView';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectWpRecoBanners = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.recoBanners,
);
const selectWpRecoGroups = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.recoGroups,
);

const getRecommendInfo = createSelector(
  state => {
    return state.wallpaper;
  },
  info => {
    return info.recommendInfo;
  },
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

function WPRecommend({ pageType, source }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = useLocation();
  const { action } = history;
  const pageContent = useRef();
  const logInfoData = useSelector(selectLogInfo);
  const recommendInfo = useSelector(getRecommendInfo);
  const bannersData = useSelector(selectWpRecoBanners);
  const groupsData = useSelector(selectWpRecoGroups);
  const userInfo = useSelector(selectUserInfo);

  const [showNumber, setShowNumber] = useState(8);

  const [initTime, setInitTime] = useState(+new Date());

  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: `P_${source}`,
        label: '',
        param2: {
          source: source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: source,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  });

  useActivate(() => {
    setInitTime(+new Date());
    // if (action === 'PUSH' || action === 'REPLACE') {
    //   dispatch(getRecoBanner({ pageType: pageType }));
    //   dispatch(getRecoGroup({ pageType: pageType }));
    // }
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  useEffect(() => {
    pagePvLog();
    if (window.external && window.external.get_wallpaper_carousel_switch_info) {
      let switchData = JSON.parse(window.external.get_wallpaper_carousel_switch_info()) || {};
      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'R_Wallpaper_Loop_Status',
          label: '',
          param2: {
            source: source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            status: switchData.switch === 'on' ? 1 : 0,
          },
        }),
      );
    }
  }, []);
  useActivate(() => {
    pagePvLog();
  });

  useEffect(() => {
    dispatch(getRecoBanner({ pageType: pageType }));
    dispatch(getRecoGroup({ pageType: pageType }));
  }, [userInfo]);

  useEffect(() => {
    if (
      (action !== 'POP' || !recommendInfo.list || recommendInfo.list.length === 0) &&
      pathname === `${CONTEXT}/wallpaper/wprecommend`
    ) {
      dispatch(
        getRecommendList({
          ...recommendInfo.pagenation,
          refresh: true,
          skip: 0,
        }),
      );
    }
  }, [userInfo]);

  const loadMore = async () => {
    if (!recommendInfo.load) {
      await dispatch(
        getRecommendList({
          ...recommendInfo.pagenation,
          refresh: false,
        }),
      );
    }
  };

  // 监听浏览器大小变化自动适应
  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = useCallback(e => {
    const clientWidth = (document.body && document.body.clientWidth) || 1060;
    if (clientWidth < 1330) {
      setShowNumber(8);
    } else if (clientWidth >= 1330 && clientWidth < 1465) {
      setShowNumber(10);
    } else if (clientWidth >= 1465 && clientWidth < 1600) {
      setShowNumber(11);
    } else if (clientWidth >= 1600 && clientWidth < 1870) {
      setShowNumber(13);
    } else if (clientWidth >= 1870) {
      setShowNumber(16);
    }
  }, []);

  const getClassType = useCallback((index = 0, number = 8) => {
    const series = {
      8: {
        small: [1, 6],
        small_space: [2, 3, 7, 0],
        big: [4],
        big_space: [5],
      },
      10: {
        small: [1, 7],
        small_space: [2, 3, 4, 8, 9, 0],
        big: [5],
        big_space: [6],
      },
      11: {
        small: [1, 8],
        small_space: [2, 3, 4, 9, 10, 0],
        big: [5],
        big_space: [6, 7],
      },
      13: {
        small: [1, 9],
        small_space: [2, 3, 4, 5, 10, 11, 12, 0],
        big: [6],
        big_space: [7, 8],
      },
      16: {
        small: [1, 11],
        small_space: [2, 3, 4, 5, 6, 12, 13, 14, 15, 0],
        big: [7],
        big_space: [8, 9, 10],
      },
    };
    const pos = (index + 1) % parseInt(number);
    let classType = 'small';
    if (series[number].small.indexOf(pos) > -1) {
      classType = 'small';
    }
    if (series[number].small_space.indexOf(pos) > -1) {
      classType = 'small_space';
    }
    if (series[number].big.indexOf(pos) > -1) {
      classType = 'big';
    }
    if (series[number].big_space.indexOf(pos) > -1) {
      classType = 'big_space';
    }
    return classType;
  }, []);

  if ((!bannersData || !bannersData.dataList || !groupsData) && action !== 'POP') {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  const judgeLoading = () => {
    if (
      Object.keys(bannersData).length === 0 &&
      groupsData?.length === 0 &&
      pathname === `${CONTEXT}/wallpaper/wprecommend` &&
      recommendInfo.pagenation.count < 1
    ) {
      return true;
    } else if (
      Object.keys(bannersData).length === 0 &&
      groupsData?.length === 0 &&
      pathname !== `${CONTEXT}/wallpaper/wprecommend`
    ) {
      return true;
    } else {
      return false;
    }
  };

  const changView = data => {
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'I_Content_Show',
        label: '',
        param2: {
          source: source,
          rankCode: data?.rankCode,
          pageCardTitle: data?.pageCardTitle ?? '',
          pageCardId: data?.pageCardContentId ?? data?.pageCardId,
          source_p: logInfoData?.source_p,
          cardType: data?.cardType,
        },
      }),
    );
  };

  return (
    <div
      className={`${judgeLoading() ? styles.page_no_overflow : styles.page}`}
      ref={pageContent}
      pagescroll="PCStore_Page_Scroll"
    >
      <div className={styles.page_container}>
        {showNumber && (
          <InfiniteScroll
            pageStart={1}
            loadMore={loadMore}
            hasMore={
              (pathname === `${CONTEXT}/wallpaper/wprecommend` &&
                recommendInfo.list.length < recommendInfo.pagenation.count) ??
              false
            }
            loader={
              <div className="loader" key={0}>
                ----------加载中----------
              </div>
            }
            initialLoad={false}
            useWindow={false}
            getScrollParent={() => pageContent.current}
            threshold={800}
          >
            <div className={styles.page_default}>
              {bannersData && bannersData.dataList && bannersData.dataList.length > 0 && (
                <CardIndex
                  data={bannersData}
                  logInfo={{
                    tag: source,
                    pageSource: 'recommend',
                    changView: data => changView(data),
                  }}
                />
              )}

              {groupsData &&
                groupsData.length > 0 &&
                groupsData.map((item, i) => {
                  return (
                    <CardIndex
                      key={i}
                      data={{ ...item, node: pageContent.current }}
                      logInfo={{
                        tag: source,
                        pageSource: 'recommend',
                        changView: data => changView(data),
                      }}
                    />
                  );
                })}
            </div>
            {recommendInfo && recommendInfo.list && recommendInfo.list.length > 0 && (
              <div className={styles.recommend_list}>
                <div className={styles.title}>{recommendInfo.name}</div>
                <div className={styles.recommend}>
                  {recommendInfo.list.map((item, index) => {
                    return (
                      <WallpaperCard
                        wallpaper={item}
                        key={index}
                        cardInfo={{
                          pageSource: 'recommend',
                          pageTage: '',
                          classType: getClassType(index, showNumber),
                          isCollect: true,
                          isWallpaper: true,
                          isDeleteColl: false,
                          isDeleteUsed: false,
                          isPreview: true,
                        }}
                        logInfo={{ source: source }}
                      />
                    );
                  })}
                </div>
                {recommendInfo.list.length >= recommendInfo.pagenation.count &&
                  recommendInfo.pagenation.count > 3 && (
                    <div className="loader">----------到底啦----------</div>
                  )}
              </div>
            )}
          </InfiniteScroll>
        )}
        <div className={styles.wp_scroll}>
          <ScrollTopWhite node={pageContent.current} quickly={true} />
        </div>
      </div>
      {Object.keys(bannersData).length === 0 &&
        groupsData?.length === 0 &&
        pathname === `${CONTEXT}/wallpaper/wprecommend` &&
        recommendInfo.pagenation.count < 1 && (
          <div className={styles.blank}>
            <Blank load={recommendInfo.load} more />
          </div>
        )}
    </div>
  );
}
// });

export default props => (
  <KeepAlive name="wallpaper">
    <WPRecommend {...props} />
  </KeepAlive>
);
